// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { SoccerGoalAnimation } from '../components';
import selectSoccerGoalAnimationProps from '../selectors/specifics/selectSoccerGoalAnimationProps';

type SoccerGoalAnimationContainerProps = {
  className?: string;
  matchId: number;
};

const SoccerGoalAnimationContainer = ({ matchId, ...ownProps }: SoccerGoalAnimationContainerProps) => {
  const selectorProps = useMemo(() => ({ matchId }), [matchId]);
  const selectedProps = useSelector((state) => selectSoccerGoalAnimationProps(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <SoccerGoalAnimation {...enhancedProps} />;
};

export default SoccerGoalAnimationContainer;
